import imageDe from '../images/de/uploader-ascensiaContour-3.png';
import imageEn from '../images/en/uploader-ascensiaContour-3.png';
import imageEs from '../images/es/uploader-ascensiaContour-3.png';
import imageFi from '../images/fi/uploader-ascensiaContour-3.png';
import imageFr from '../images/fr/uploader-ascensiaContour-3.png';
import imageIt from '../images/it/uploader-ascensiaContour-3.png';
import imageNo from '../images/no/uploader-ascensiaContour-3.png';
import imageSv from '../images/sv/uploader-ascensiaContour-3.png';

export const uploaderUploadingImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
